export default __webpack_public_path__ + "static/media/Forest_00.ce5aa02b.png";